import { render, staticRenderFns } from "./addnew_warranties_center.vue?vue&type=template&id=a9780d2c&"
import script from "./addnew_warranties_center.vue?vue&type=script&lang=js&"
export * from "./addnew_warranties_center.vue?vue&type=script&lang=js&"
import style0 from "./addnew_warranties_center.vue?vue&type=style&index=0&id=a9780d2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports